<template>
  <div class="thankyou" >
    <h1 class="fn-title-1 thankyou-title">
      Дякуємо
    </h1>
    <p>
      Ваші документи успішно підписані і відправлені до банку.
      Протягом робочої доби на Ваш поточий рахунок у Альянс Банку будуть надані кредитні гроші.
    </p>
    <p>
      До фактичної видачи коштів на рахунок Ви можете повернутися до будь якого документа кліком на його назві та в разі потреби:
    </p>
    <ul class="conditions">
      <li>Надіслати запрошення на e-mail іншому користувачеві, якщо є необхідність ознайомлення з документом та/або його підписання іншою особою;</li>
      <li>Відправити собі на пошту оригінал документа;</li>
      <li>Роздрукувати документ;</li>
      <li>Зберегти документ собі на комп'ютер;</li>
      <li>Підписати повторно.</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'DocumentsSuccess'
}
</script>

<style lang="less" scoped>
.thankyou {
  padding: 56px;
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  overflow-y: auto;
}
.thankyou-title {
  display: block;
  width: 100%;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--grey-230);
  margin-bottom: 56px;
}
</style>
